import { ready } from './utils';
import { showMoreReviews } from './show-more';
import { cf7MaskTelValidation } from './cf7-mask-for-tel';
import { choicesSelect } from './choices-select';
import { openFirstAccordion } from './accordions-pre-open';
import { heritageSliders } from './sliders';
import { locationsSwitcher } from './locations-switcher';
import { scheduleEnginePreventDefault } from './schedule-engine-prevent-default';

ready(() => {
  cf7MaskTelValidation();
  choicesSelect();
  openFirstAccordion();
  heritageSliders();
  locationsSwitcher();
  scheduleEnginePreventDefault();
  showMoreReviews();
});
